webpackJsonp([8],{

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  function staySubscribedModal() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-nothanks-unsubscribe-me').on('click', function (e) {
      e.preventDefault();

      // $('.js-modal-close')[0].click();

      var formname = "emailPref2";
      var email = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#emailValueForUnsubscribe").val();
      var reasonSelectValue = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#reason_select option:selected").text();
      var allUnsubscribeValue = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#unsub-all")[0].checked;
      var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        formname: formname,
        email: email,
        unsubscribe: "true",
        feedback: reasonSelectValue,
        allUnsub: allUnsubscribeValue
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post("/r/ajax/unsubscribeSubmit.jsp", data, function (msg) {
        if (typeof msg.success == 'undefined') {
          msg = JSON.parse(msg);
        }
        if (msg.success || msg.success == 'true') {
          window.location.href = 'Unsubscribed.jsp?unsubscribed=true';
        } else {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-modal-close').mousedown();
          var errorMessage = "We're sorry, an error occurred while attempting to unsubscribe you. Please contact sales@revolve.com for further assistance.";
          if (msg.msg0 != null) {
            errorMessage = msg.msg0;
          }
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#unsubscribe_id").closest('.field').addClass("is-error");
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#unsubscribe_id").html(errorMessage);
        }
      });
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-stay-subscribed').on('click', function (e) {
      e.preventDefault();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        url: './confirmation-promo-modal.jsp',
        triggerOpen: true,
        padding: false,
        fullHeight: true
      });
    });
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-unsubscribe-form').on('submit', function (e) {
    e.preventDefault();
    var allUnsub;
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#unsub-all').is(':checked')) {
      allUnsub = 'allUnsub';
    }
    var feedback = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#reason_select").val();
    if (feedback != null && feedback == 'Select') {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#unsubscribe_id").closest('.field').addClass("is-error");
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#reason_select').focus();
      return false;
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#unsubscribe_id").closest('.field').removeClass("is-error");
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#reason_select').focus();
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: "./discount-offer-modal.jsp",
      triggerOpen: true,
      returnFocus: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this),
      padding: false,
      fullHeight: true,
      onComplete: function onComplete() {
        staySubscribedModal();
      }
    });
  });
  if (window.location.href.indexOf("Unsubscribed.jsp") > -1) {
    var urlParams = new URLSearchParams(window.location.search);
    var unsubscribedTrue = urlParams.get('unsubscribed');
    if (unsubscribedTrue) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        url: "./unsubscribe-notification-modal.jsp",
        triggerOpen: true,
        type: 'small'
      });
    }
  }

  // Edit: close others, open this row
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click', '.js-edit-sm', function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.card__entry-section.is-editing').removeClass('is-editing');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest('.card__entry-section').addClass('is-editing').find('.sm-input').focus();
  });
});

/***/ })

},[252]);


// WEBPACK FOOTER //
// dist/settings.js